import { findTimeElapsedSinceMidnight } from "utils/datesAndTimes/findTimeElapsedSinceMidnight";
import { indexOfLargest } from "utils/indexOfLargest";
import { indexOfSmallest } from "utils/indexOfSmallest";

export function findBoundaryTime(
	dates: Date[],
	midnightIsLate: boolean,
	isEarliest: boolean
): moment.Duration | undefined {
	if (dates.length === 0) {
		return undefined;
	}

	const durations = dates.map(findTimeElapsedSinceMidnight);
	if (midnightIsLate) {
		for (const duration of durations) {
			if (duration.hours() === 0) {
				duration.add(24, "hours");
			}
		}
	}

	const ms = durations.map(duration => duration.as("milliseconds"));

	const indexFinder = isEarliest ? indexOfSmallest : indexOfLargest;
	return durations[indexFinder(ms)];
}
